import React from 'react';
import { ReactComponent as LogoSvg } from './IconWhite.svg';

const LogoIcon = ({ size = 48, className, ...props }) => {
  const dimensionProps =
    typeof size === 'number' && !Number.isNaN(size)
      ? { width: size, height: size }
      : {};

  return (
    <LogoSvg
      {...dimensionProps}
      className={className}
      aria-hidden="true"
      focusable="false"
      {...props}
    />
  );
};

export default LogoIcon;
